import { __assign, __awaiter, __decorate, __extends, __generator, __metadata, __read, __spread } from "tslib";
import { app as api } from '@ekuaibao/whispered';
import React, { PureComponent, useCallback, useState } from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import { forEach } from 'lodash';
import { Form } from 'antd';
import { showMessage } from '@ekuaibao/show-util';
import classNames from './CommentComponent.module.less';
import { getDisplayName } from '../../../../elements/utilFn';
import { EnhanceConnect } from '@ekuaibao/store';
import { getBoolVariation } from '../../../../lib/featbit';
var typePlaceholder = {
    comment: '请输入审批意见，可以通过空格+@提醒他人',
    mention: '添加评论（不超过 1000 个字，可通过空格+@姓名提醒其他人查看）'
};
var typeText = {
    comment: '审批意见',
    mention: '评论内容'
};
var typeMax = {
    comment: 1400,
    mention: 1000
};
var enumType = {
    filterScope: 'UNLIMITED',
};
var CommentComponent = (function (_super) {
    __extends(CommentComponent, _super);
    function CommentComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.fnFormatStaffId = function (id, decode) {
            if (id === void 0) { id = ''; }
            if (decode === void 0) { decode = false; }
            if (id === null || id === void 0 ? void 0 : id.includes('$$')) {
                return encodeURIComponent(id);
            }
            if (decode) {
                return decodeURIComponent(id);
            }
            return id;
        };
        _this.handleMentionResult = function () {
            return new Promise(function (resolve, reject) {
                var _a = _this.props, required = _a.required, type = _a.type;
                var validateFields = _this.props.form.validateFields;
                validateFields(function (errors, values) {
                    var _a;
                    if (!!errors) {
                        return reject();
                    }
                    if (values && ((_a = values.comment) === null || _a === void 0 ? void 0 : _a.value)) {
                        var _b = values.comment, value = _b.value, mentions = _b.mentions;
                        if ((!value || (value && value.length === 0)) && required) {
                            showMessage.error(i18n.get(typeText[type] + "\u4E0D\u80FD\u4E3A\u7A7A"));
                            return reject();
                        }
                        var participants = mentions.map(function (mention) { return _this.fnFormatStaffId(mention.id, true); });
                        resolve({ comment: decodeURIComponent(value.replace(/%/g, '%25')), participants: participants });
                    }
                    return resolve({});
                });
            });
        };
        _this.formatStaffList = function (staffs) {
            return Object.keys(staffs).map(function (key) {
                var _a, _b;
                var staffName = getDisplayName(staffs[key]);
                var deptName = getDisplayName((_a = staffs[key]) === null || _a === void 0 ? void 0 : _a.defaultDepartment);
                return {
                    display: staffName,
                    id: _this.fnFormatStaffId(staffs[key].id),
                    avatar: staffs[key].avatar,
                    deparmentName: deptName,
                    deparmentId: (_b = staffs[key].defaultDepartment) === null || _b === void 0 ? void 0 : _b.id
                };
            });
        };
        _this.checkMention = function (rule, value, callback) {
            var _a;
            var contentString = (_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : '';
            var _b = _this.props, required = _b.required, type = _b.type;
            if (!contentString && required) {
                callback(i18n.get(typeText[type] + "\u4E0D\u80FD\u4E3A\u7A7A"));
            }
            var len = _this.fnGetCheckLength(value);
            if (len > typeMax[type]) {
                callback(new Error(i18n.get(typeText[type] + "\u4E0D\u80FD\u8D85\u8FC7 " + typeMax[type] + " \u4E2A\u5B57")));
            }
            else {
                callback();
            }
        };
        _this.fnGetCheckLength = function (mentionValue) {
            var _a, _b;
            var mentions = (_a = mentionValue === null || mentionValue === void 0 ? void 0 : mentionValue.mentions) !== null && _a !== void 0 ? _a : [];
            var str = (_b = mentionValue === null || mentionValue === void 0 ? void 0 : mentionValue.value) !== null && _b !== void 0 ? _b : '';
            mentions.forEach(function (item) {
                var reg = new RegExp("{" + item.id + "}", 'g');
                str = str.replace(reg, "" + item.display);
            });
            return str.length;
        };
        _this.fnGetClickName = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var staffMap = _this.state.staffMap;
            var staff = staffMap[args[0]];
            var name = getDisplayName(staff);
            return "@" + ((_a = name === null || name === void 0 ? void 0 : name.trim()) !== null && _a !== void 0 ? _a : '');
        };
        _this.state = {
            staffMap: null,
            staffList: [],
            filterSuggestions: [],
            list: [],
            suggestionList: [],
            allList: [],
            filterScope: '',
            batchLoading: getBoolVariation('batch-loading-mention')
        };
        return _this;
    }
    CommentComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, bus, suggestionData, suggestionIds, res, filterScope;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, bus = _a.bus, suggestionData = _a.suggestionData;
                        bus.watch('get:mention:content', this.handleMentionResult);
                        suggestionIds = suggestionData === null || suggestionData === void 0 ? void 0 : suggestionData.map(function (item) { return _this.fnFormatStaffId(item === null || item === void 0 ? void 0 : item.id); }).filter(Boolean);
                        return [4, this.loadCommonStaffsVisibility(suggestionIds)];
                    case 1:
                        _b.sent();
                        return [4, api.dataLoader('@common.organizationConfig').load()];
                    case 2:
                        res = _b.sent();
                        if (!res) {
                            return [2];
                        }
                        filterScope = res.filterScope;
                        this.setState({ filterScope: filterScope });
                        if (!(filterScope === enumType.filterScope)) return [3, 4];
                        return [4, this.loadStaffsVisibility()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    CommentComponent.prototype.componentWillUnmount = function () {
        var bus = this.props.bus;
        bus.un('get:mention:content', this.handleMentionResult);
    };
    CommentComponent.prototype.loadCommonStaffsVisibility = function (suggestionIds) {
        return __awaiter(this, void 0, void 0, function () {
            var staffService, staffList, staffMap, allList, suggestionList, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        staffService = this.state.batchLoading ? 'staffsVisibility' : 'commonStaffsVisibility';
                        return [4, api.dataLoader("@common." + staffService).load()];
                    case 1:
                        staffList = _a.sent();
                        staffMap = this.createStaffMap(staffList);
                        allList = this.formatStaffList(staffMap);
                        suggestionList = allList.filter(function (item) { return (suggestionIds || []).includes(item.id); });
                        list = allList;
                        if (this.state.batchLoading) {
                            list = list.slice(0, 100);
                        }
                        this.setState({ staffMap: staffMap, staffList: staffList, list: list, allList: allList, suggestionList: suggestionList });
                        return [2];
                }
            });
        });
    };
    CommentComponent.prototype.loadStaffsVisibility = function () {
        return __awaiter(this, void 0, void 0, function () {
            var staffList, staffsVisibilityMap, allList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        staffList = this.props.staffs;
                        if (!!staffList) return [3, 2];
                        return [4, api.dataLoader('@common.staffsVisibility').load()];
                    case 1:
                        staffList = _a.sent();
                        _a.label = 2;
                    case 2:
                        staffsVisibilityMap = this.createStaffMap(staffList);
                        allList = this.formatStaffList(staffsVisibilityMap);
                        this.setState({ staffMap: staffsVisibilityMap, staffList: __spread(this.state.staffList, staffList), allList: allList });
                        return [2];
                }
            });
        });
    };
    CommentComponent.prototype.createStaffMap = function (staffList) {
        var _this = this;
        var staffMap = {};
        forEach(staffList, function (staff) {
            var newStaff = __assign(__assign({}, staff), { displayName: _this.fnFormatStaffId(staff === null || staff === void 0 ? void 0 : staff.id) });
            staffMap[newStaff.displayName] = newStaff;
        });
        return staffMap;
    };
    CommentComponent.prototype.render = function () {
        var _a = this.state, list = _a.list, allList = _a.allList, filterScope = _a.filterScope;
        var _b = this.props.type, type = _b === void 0 ? 'mention' : _b;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Form, { layout: "horizontal" },
            React.createElement(Form.Item, null, getFieldDecorator('comment', {
                rules: [{ validator: this.checkMention }]
            })(React.createElement(MentionComponentUse, { data: list, displayTransform: this.fnGetClickName, type: type, allList: allList, filterScope: filterScope })))));
    };
    CommentComponent = __decorate([
        EnhanceConnect(function (state) { return ({
            staffs: state['@common'].staffs
        }); }),
        __metadata("design:paramtypes", [Object])
    ], CommentComponent);
    return CommentComponent;
}(PureComponent));
export default CommentComponent;
var MentionComponentUse = function (props) {
    var data = props.data, displayTransform = props.displayTransform, _a = props.value, value = _a === void 0 ? '' : _a, onChange = props.onChange, type = props.type, allList = props.allList, filterScope = props.filterScope;
    var _b = __read(useMentionValue(value), 2), targetValue = _b[0], onTargetChange = _b[1];
    var _c = __read(useState(data), 2), filteredData = _c[0], setFilteredData = _c[1];
    var handleChange = function (event, newValue, newPlainTextValue, mentions) {
        onTargetChange(event, newValue, newPlainTextValue, mentions);
        onChange && onChange({ value: newValue, mentions: mentions });
        if (getBoolVariation('batch-loading-mention')) {
            if (newPlainTextValue.trim().endsWith('@')) {
                setFilteredData(data);
            }
            else {
                setFilteredData(allList);
            }
        }
        else {
            setFilteredData(data);
        }
        if (filterScope === enumType.filterScope) {
            handleSearch(newPlainTextValue);
        }
    };
    var processString = function (str) {
        str = str.trim();
        if (str === '@' || str.endsWith(' @')) {
            return { isData: true, searchText: '' };
        }
        var atIndex = str.lastIndexOf('@');
        if (atIndex !== -1 && atIndex < str.length - 1) {
            var afterAt = str.slice(atIndex + 1).trim();
            if (afterAt) {
                return { isData: false, searchText: afterAt };
            }
        }
        return { isData: false, searchText: '' };
    };
    var handleSearch = function (newPlainTextValue) {
        var lines = newPlainTextValue.split('\n');
        lines.forEach(function (line) {
            var _a = processString(line), isData = _a.isData, searchText = _a.searchText;
            if (isData || filterScope !== enumType.filterScope) {
                setFilteredData(data);
            }
            else {
                setFilteredData(allList.filter(function (item) { return item.display === searchText; }));
            }
        });
    };
    return (React.createElement(MentionComponent, { value: targetValue, onChange: handleChange, data: filteredData, displayTransform: displayTransform, type: type }));
};
import { Avatar } from '@hose/eui';
var MentionComponent = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, data = _a.data, onChange = _a.onChange, displayTransform = _a.displayTransform, type = _a.type;
    return (React.createElement(MentionsInput, { value: value, className: 'mentions', classNames: classNames, onChange: onChange, placeholder: i18n.get(typePlaceholder[type]) },
        React.createElement(Mention, { trigger: "@", className: classNames.mentions__mention, displayTransform: displayTransform, markup: "{__id__}", data: data, renderSuggestion: function (suggestion, search, highlightedDisplay, index, focused) { return (React.createElement(React.Fragment, null,
                React.createElement(Avatar, { size: "small", shape: "circle", style: { height: 16, width: 16, marginRight: 5, lineHeight: '16px' }, src: suggestion === null || suggestion === void 0 ? void 0 : suggestion.avatar }),
                React.createElement("span", null, highlightedDisplay),
                suggestion.deparmentName && React.createElement("span", null,
                    "(",
                    suggestion.deparmentName,
                    ")"))); }, appendSpaceOnAdd: true })));
};
function useMentionValue(initialValue) {
    var _a = __read(useState(initialValue), 2), value = _a[0], setValue = _a[1];
    var onChange = useCallback(function (_, newValue) { return setValue(newValue); }, [setValue]);
    return [initialValue.value, onChange];
}
